import { Alert } from '@creditornot/cb-alert';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { MOBILE_BREAKPOINT } from 'common/hooks/useIsMobile';
import Loading from 'core/Loading';
import { DiscountedItem } from 'modules/campaigns/hooks/useDiscountedItems';

import { SelectedDiscountItem } from './SelectedDiscountItem';
import { SelectedDiscountedItemsModal } from './SelectedDiscountedItemsModal';

type DiscountedItemsGridProps = {
  selectedItemIds: string[];
  menuItems: DiscountedItem[];
  isLoadingMenuData: boolean;
  onEditClick?: () => void;
};

const SelectedItemsGrid = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;

  @media (width < ${MOBILE_BREAKPOINT}px) {
    grid-template-columns: 1fr;
  }
`;

const MAX_VISIBLE_ITEM_COUNT = 16;

export const DiscountedItemsGrid = ({
  selectedItemIds,
  menuItems,
  isLoadingMenuData,
  onEditClick,
}: DiscountedItemsGridProps) => {
  if (isLoadingMenuData) {
    return <Loading />;
  }

  const selectedItems = menuItems.filter(item => selectedItemIds.includes(item.id));
  const hasMissingItems = selectedItemIds.length > selectedItems.length;

  const visibleItems = selectedItems.slice(0, MAX_VISIBLE_ITEM_COUNT);
  const hasMoreItems = visibleItems.length < selectedItems.length;

  return (
    <>
      <SelectedItemsGrid>
        {visibleItems.map(item => (
          <SelectedDiscountItem key={item.id} item={item} />
        ))}
        {hasMissingItems && (
          <Alert variant="error">
            <FormattedMessage id="campaigns.form.item.no-item" />
          </Alert>
        )}
      </SelectedItemsGrid>
      {hasMoreItems && <SelectedDiscountedItemsModal selectedItems={selectedItems} onEditClick={onEditClick} />}
    </>
  );
};
